<template>
  <div class="page sizeA4">
    <div class="m-4">
      <!-- imagens do topo -->
      <div class="row">
        <div class="d-flex justify-content-between mb-2">
          <div class="col-md-6">
            <img
              style="width: 60%"
              src="@/assets/images/extrato/unicampoLogo.jpg"
            />
          </div>
          <div class="col-md-6">
            <div class="barraVerde"></div>
          </div>
        </div>
      </div>
      <div v-if="!cabecalho" class="d-flex justify-content-center">
        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
      </div>
      <div v-else>
        <!-- informações do cooperado -->
        <div class="row">
          <div class="col-md-12 mb-4">
            <h1 class="text-dark fw-bolder">
              Olá, {{ this.header.NM_RAZAO }}!
            </h1>
            <h1 class="text-dark fw-bolder">
              Aqui está a
              <span class="text-success">memória de cálculo</span>
              da sua conta capital do fechamento do ano
              <span class="text-success">{{
                this.dados[0].ANO_FECHAMENTO
              }}</span>
            </h1>
          </div>
        </div>
        <!-- informações da folha -->
        <div class="row">
          <div class="d-flex flex-column mb-2">
            <div>
              <label class="text-dark fw-bolder me-2 col-md-2"
                >COOPERADO(A)</label
              >
              <span class="fw-bold text-sencodary mx-4">
                {{ this.header.NM_RAZAO }}
              </span>
            </div>
            <div>
              <label class="text-dark fw-bolder me-2 col-md-2">MATRÍCULA</label>
              <span class="fw-bold text-sencodary mx-4">
                {{ this.header.NR_MATRICULA }}
              </span>
            </div>
            <div>
              <label class="text-dark fw-bolder me-2 col-md-2"
                >DATA ADMISSÃO</label
              >
              <span class="fw-bold text-sencodary mx-4">
                {{ $tools.converteData(this.header.DT_ADMISSAO) }}
              </span>
            </div>
            <div>
              <label class="text-dark fw-bolder me-2 col-md-2"
                >STATUS DA MATRÍCULA</label
              >
              <span class="fw-bold text-sencodary mx-4">
                {{ this.header.STATUS_MATRICULA }}
              </span>
            </div>
            <div v-if="this.header.DT_DESLIGAMENTO != null">
              <label class="text-dark fw-bolder me-2 col-md-2"
                >DATA DESLIGAMENTO</label
              >
              <span class="fw-bold text-sencodary mx-4">
                {{ $tools.converteData(this.header.DT_DESLIGAMENTO) }}
              </span>
            </div>
          </div>
        </div>
        <!-- resumo de valores do cooperado -->
        <div class="row justify-content-center">
          <div
            class="d-flex justify-content-center flex-column text-center my-2 p-3 w-50"
            style="background-color: #f8f9fa"
          >
            <h5 class="text-dark fw-bolder">Ano Fechamento</h5>
            <span class="text-success fw-bolder font-size-24">
              {{ this.dados[0].ANO_FECHAMENTO }}
            </span>
            <h5 class="text-dark fw-bolder">Data Fechamento</h5>
            <span class="text-success fw-bolder font-size-24">
              {{ this.dados[0].DT_FECHAMENTO }}
            </span>

            <h5 class="text-dark fw-bolder">Saldo Pré-Fechamento</h5>
            <span class="text-success fw-bolder font-size-24">
              {{ $tools.converteReal(this.filtroMemoriaCalculo[2]) }}
            </span>

            <h5 class="text-dark fw-bolder">Saldo Pós-Fechamento</h5>
            <span class="text-success fw-bolder font-size-24">
              {{ $tools.converteReal(this.filtroMemoriaCalculo[3]) }}
            </span>
          </div>
        </div>

        <!-- RODAPÉ -->
        <div class="row quebraPagina">
          <div class="d-flex justify-content-between mt-5">
            <div class="col-md-6 align-self-end">
              <div class="barraVerde"></div>
            </div>
          </div>
        </div>

        <!-- imagens do topo -->
        <div class="row">
          <div class="d-flex justify-content-between mb-2">
            <div class="col-md-6">
              <img
                style="width: 60%"
                src="@/assets/images/extrato/unicampoLogo.jpg"
              />
            </div>
            <div class="col-md-6">
              <div class="barraVerde"></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mb-4 text-center">
            <h5 class="text-dark fw-bolder">
              DETALHAMENTO DOS VALORES DA CONTA CAPITAL
            </h5>
            <h6 class="text-dark fw-bolder">MEMORIA DE CÁLCULO</h6>
            <h6 class="text-dark fw-bolder">
              ANO {{ this.dados[0].ANO_FECHAMENTO }}
            </h6>
          </div>
          <div class="d-flex flex-column mb-2">
            <div>
              <label class="text-dark fw-bolder me-2 col-md-2"
                >COOPERADO(A)</label
              >
              <span class="fw-bold text-sencodary mx-4">
                {{ this.header.NM_RAZAO }}
              </span>
            </div>
            <div>
              <label class="text-dark fw-bolder me-2 col-md-2">MATRÍCULA</label>
              <span class="fw-bold text-sencodary mx-4">
                {{ this.header.NR_MATRICULA }}
              </span>
            </div>
          </div>
          <b-table
            responsive="sm fw-bold"
            :items="dados"
            :fields="camposMemoriaCalc"
            per-page="1000"
            striped
          >
          </b-table>
        </div>

        <div class="row">
          <div class="d-flex justify-content-between mt-5">
            <div class="col-md-6 align-self-end">
              <div class="barraVerde"></div>
            </div>
            <div class="col-md-6 d-flex flex-column">
              <label class="ms-5 fw-bold">44 4009-3800</label>
              <label class="ms-5 fw-bold">unicampo@unicampo.coop.br</label>
              <label class="ms-5 fw-bold">www.unicampo.coop.br</label>
              <label class="ms-5 fw-bold"
                >Av. Carneiro Leão, 65 Sala 1409 -
                <strong>MARINGÁ PR</strong> CEP: 87013-072</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import contaCapitalMixin from "@/tools/mixins/contaCapitalMixin";
export default {
  mixins: [contaCapitalMixin],
  layout: "empty",
  data() {
    return {
      cabecalho: true,
      perPage: 100,
      currentPage: 1,
      rows: 0,
      filtroMemoriaCalculo: [],
      camposMemoriaCalc: [
        {
          key: "DT_MOVTO",
          label: "Data",
          class: "fw-bolder",
          formatter: (value) => {
            return this.$tools.converteData(value);
          },
        },
        {
          key: "DS_OPERACAO",
          label: "Tipo de Lançamento",
          class: "fw-bolder",
        },
        {
          key: "VL_CREDITO",
          label: "Crédito",
          class: "alinharCelulaDireita fw-bolder",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
        {
          key: "VL_DEBITO",
          label: "Débito",
          class: "alinharCelulaDireita fw-bolder",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
        {
          key: "QT_DIAS_PREVISAO",
          label: "dias Juros",
          class: "alinharCelula fw-bolder",
        },
        {
          key: "VL_JUROS_PREVISAO",
          label: "Valor Juros",
          class: "alinharCelulaDireita fw-bolder",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
      ],
      memoriaCalc: [],
      header: {},
      dados: [],
      fechamento: [],
    };
  },
  async created() {
    this.$store.commit("SET_MOSTRA_MENU", false);
    this.filtroMemoriaCalculo = this.$store.state.filtroMemoriaCalculo;
    this.header = this.$store.state.headerMemoriaCalculo;
    this.fechamento = this.$store.state.fechamentoContaCapital;
    let ano = this.filtroMemoriaCalculo[0];
    let nr_matricula = this.filtroMemoriaCalculo[1];
    this.dados = await this.buscarMemoriaCalculo(ano, nr_matricula);
  },
};
</script>